import * as yup from 'yup'

// VISTA GENERAR ORDEN DE LOTE ----------------------------------------------------------------------
export const orderGenerateLaundryBatch = yup.object().shape({
  companiaId: yup.string().required('La compañía es obligatorio'),
  clienteId: yup.string().required('El cliente es obligatorio'),
  siteId: yup.string().required('El site es obligatorio'),
  campamentoId: yup.string().required('El campamento es obligatorio'),
  tipoProceso: yup.string().required('El tipo de proceso es obligatorio'),
  tipoAdministracion: yup.string().required('El tipo de proceso es obligatorio'),
  tipoLavado: yup.string().required('El tipo de lavado es obligatorio'),
})

export const processWashEBatch = yup.object().shape({
  proveedorId: yup.string().required('El proveedor es obligatorio'),
  fechaEntregaProveedor: yup.string().required('La fecha es obligatorio'),
  fechaProgramadaProveedor: yup.string().required('La fecha es obligatorio'),
})
export const processWashCBatch = yup.object().shape({
  puntoId: yup.string().required('El punto es obligatorio'),
  fechaRealLavado: yup.string().required('La fecha es obligatorio'),
})
export const processOutBatch = yup.object().shape({
  lugarSalida: yup.string().required('El lugar es obligatorio'),
  responsableId: yup.string().required('El responsable es obligatorio'),
  fechaSalida: yup.string().required('La fecha es obligatorio'),
})
// VISTA ORDEN DE LOTE ----------------------------------------------------------------------
export const orderLaundryBatch = yup.object().shape({
  tipoLavado: yup.string().required('El tipo de lavado es obligatorio'),
})

export const endProcessWashBatchSchema = yup.object().shape({
  tipeAdmin: yup.string().required('El Administrador es obligatorio'),
  fechaRealSalida: yup.string().when('tipeAdmin', {
    is: (valorCampoResponsable) => valorCampoResponsable === 'COMPAÑÍA',
    then: yup.string().required('La fecha es obligatorio'),
    otherwise: yup.string(),
  }),
  fechaDevolucionReal: yup.string().when('tipeAdmin', {
    is: (valorCampoResponsable) => console.log(valorCampoResponsable !== 'COMPAÑÍA'),
    then: yup.string().required('La fecha es obligatorio'),
    otherwise: yup.string(),
  }),
})

export const cancelProcessBatchSchema = yup.object().shape({
  motivo: yup.string().required('El motivo es obligatorio'),
})
